import { Directive, Input } from '@angular/core';
import { Table } from 'primeng/table';
import { TranslateService } from '@ngx-translate/core';
import { HrTableDirective } from './hr-table.directive';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
    standalone: true,
    selector: '[hrStaticTable]',
})
export class HrStaticTableDirective extends HrTableDirective<any[]>{

    constructor(primeNgTable: Table) {
        super(primeNgTable);
        this.listData$.pipe(takeUntilDestroyed()).subscribe(listData =>{
            primeNgTable.totalRecords = listData?.length ?? 0;
            primeNgTable.value = listData;
        })
    }

}
